import React, { useCallback } from 'react';

import { stopEventPropagation } from '@lyearn/core/utils/events';
import { BaseMenuItem, Typography } from '@lyearn/ui';

import { classes } from './styles';
import { EmojiListItemProps } from './types';

function EmojiListItem(props: EmojiListItemProps) {
  const { index, item, isSelected, onClick: onClickProp } = props;

  const onClick: React.MouseEventHandler<HTMLLIElement> = useCallback(
    (event) => {
      stopEventPropagation(event);
      onClickProp?.(item);
    },
    [item, onClickProp],
  );

  return (
    <BaseMenuItem
      className={classes.listItem}
      data-index={index}
      selected={isSelected}
      onClick={onClick}>
      <Typography variant="body-short-01">{item.native}</Typography>
      <Typography
        className="truncate"
        color={isSelected ? 'text-text-primary' : 'text-text-secondary'}
        variant="body-short-01">
        {item.colons}
      </Typography>
    </BaseMenuItem>
  );
}

export default EmojiListItem;
